import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/useAuth";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

   const isAuthPage = location.pathname === "/auth";

  const HIDE_ON_PATHS = [
    "/dashboard",
    "/projects",
    "/payments",
  ];

  const shouldHideNavbar = HIDE_ON_PATHS.some((path) =>
    location.pathname.startsWith(path)
  );

  if (shouldHideNavbar) return null;

 const navLinks = [
  { name: "Home", path: "#top" },
  { name: "Features", path: "#features" },
  { name: "Use Cases", path: "#use-cases" },
  { name: "Developers", path: "#developer-section" },
  { name: "How It Works", path: "#how-it-works" },
];



  return (
    <header className="fixed top-0 left-0 w-full z-50 backdrop-blur-xl bg-white border-b border-gray-200">

     <nav className="max-w-7xl mx-auto px-6 h-16 flex items-center relative">


        
        <Link to="/" className="flex items-center space-x-2">
  <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
    <span className="text-white font-bold text-xl">U</span>
  </div>
  <span className="text-2xl font-bold text-slate-900">UnifiedPay</span>
</Link>



<div className="hidden md:flex items-center mx-auto">

  {!isAuthPage && (
    <div className="flex items-center gap-10">
      {navLinks.map((link) =>
        link.path.startsWith("#") ? (

          <a key={link.name} href={link.path} className="relative font-medium text-gray-700 transition hover:text-blue-600
      after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0
      after:bg-blue-600 after:transition-all after:duration-300
      hover:after:w-full">
            {link.name}
          </a>
        ) : (
          <Link key={link.name} to={link.path} className="relative font-medium text-gray-700 transition hover:text-blue-600
      after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0
      after:bg-blue-600 after:transition-all after:duration-300
      hover:after:w-full">
            {link.name}
          </Link>
        )
      )}

      <a href="#cta-banner" className="px-4 py-2 rounded-full text-gray-700 font-medium transition hover:bg-blue-50 hover:text-blue-600">
        Contact Sales
      </a>
    </div>
  )}

  <div className="absolute right-6">
    {!user ? (
      <Link to="/auth" className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full font-medium transition">
        Sign in
      </Link>
    ) : (
      <button
        onClick={() => {
          logout();
          navigate("/");
        }}
        className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full font-medium transition"
      >
        Sign out
      </button>
    )}
  </div>
</div>

        

       
        <button
          className="md:hidden"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X /> : <Menu />}
        </button>
      </nav>

      {mobileOpen && !isAuthPage && (
        <div className="md:hidden bg-white px-6 py-4 space-y-4 border-t">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              onClick={() => setMobileOpen(false)}
              className="block text-gray-700"
            >
              {link.name}
            </Link>
          ))}

          {!user ? (
            <Link
              to="/auth"
              onClick={() => setMobileOpen(false)}
              className="block text-center px-4 py-2 rounded-lg bg-black text-white"
            >
              Sign in
            </Link>
          ) : (
            <button
              onClick={() => {
                logout();
                setMobileOpen(false);
                navigate("/");
              }}
              className="w-full px-4 py-2 rounded-lg bg-black text-white"
            >
              Sign out
            </button>
          )}
        </div>
      )}
    </header>
  );
}
